import type { ExtendedConstraints } from '../../..';
import { type CapabilityConfig, type Message } from '../../../types';
import { hasValue, isValidMessageConfig } from '../../../utils';
import * as AppletSpec from '../applet/applet';

export type Applet = AppletSpec.Applet & {
  label?: string;
};

export const id = 'modal-applet';

export enum Events {}
export enum Actions {
  Attach = 'modal-applet:attach',
  Detach = 'modal-applet:detach',
}

const VALID_CONFIG_KEYS = [
  ...AppletSpec.VALID_CONFIG_KEYS,
  'label',
  'attach',
  'onClose',
] as const;
export type Config = AppletSpec.Config & {
  type: typeof id;
  label?: string;
  attach?: boolean;
  onClose?: Message[];
};

export type Constraints = ExtendedConstraints<{
  events: Events;
  actions: Actions;
  config: Config;

  actionPayloadTuple:
    | [Actions.Attach]
    | [Actions.Detach]
    | [Actions.Attach, AppletSpec.AppletPayload]
    | [Actions.Detach, AppletSpec.AppletPayload];
}>;

export function isValidConfig(config: CapabilityConfig): config is Config {
  if (!AppletSpec.isValidConfig(config, VALID_CONFIG_KEYS)) {
    return false;
  }

  if (config.type !== id) {
    return false;
  }

  const isLabelNotValid =
    hasValue(config, 'label') && typeof config.label !== 'string';

  const isAttachNotValid =
    hasValue(config, 'attach') && typeof config.attach !== 'boolean';

  const isOnCloseNotValid =
    hasValue(config, 'onClose') &&
    (!Array.isArray(config.onClose) ||
      !config.onClose.every((m) => isValidMessageConfig(m)));

  if (isLabelNotValid || isAttachNotValid || isOnCloseNotValid) {
    return false;
  }

  return true;
}
